import React from 'react';

/**
 * 편집용 게임 제목 입력 컴포넌트
 */
export default function GameEditHeader({ value, onChange }) {
  return (
    <div className="w-1/3 text-white text-sm">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full p-2 rounded bg-[#121212] border border-gray-600 text-white font-bold text-xl"
        placeholder="게임 타이틀을 입력하세요"
      />
    </div>
  );
}